import React, { useMemo, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { isEqual } from 'lodash';
import TasksListPopover from '../workflow/TasksListPopover';
import {
  Card,
  Checkbox,
  Col,
  Form,
  InputNumber,
  notification,
  Row,
  Typography,
  Upload,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import DF from 'DisplayFramework';
import AntButton from 'components/Button';
import DataGrid from 'components/DataGrid';
import ParListSelect from 'components/ParListSelect';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import {
  LikeTwoTone,
  DislikeTwoTone,
  UserSwitchOutlined,
  UploadOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import {
  DocListSearchResponse,
  findDocumentsByAnyRef,
  FindDocumentsByAnyRefParams,
  getParDocumentByType,
  updateDocPathByDocid,
  updateDocStatusByDocid,
  addDocument,
} from 'services/Document';
import { UPLOAD_DOC_URL } from 'utils/config';
import { Document, Page } from 'react-pdf';
import Modal from 'antd/lib/modal/Modal';
import POPOverTaskList from './PopOverTaskList';
import EXECUTETask from 'pages/workflow/ExecuteTask';
import GetLabel from 'DisplayFramework/components/GetLabel';
import Text from 'antd/lib/typography/Text';
import _ from 'lodash';
import { UploadDocumentFile } from 'utils/request';

type Values = {
  document: DocListSearchResponse[];
};
export type DocListModalProps = {
  objectid?: number;
  objecttype?: string;
  tpid?: number;
  hideCol?: boolean;
  onSelect?: (item: DocListSearchResponse) => void;
};
const DocListModal = ({
  objectid,
  objecttype,
  tpid,
  hideCol,
  onSelect,
}: DocListModalProps) => {
  const [form] = Form.useForm();
  const fieldName = 'Document';
  const [searchs, setsearchs] = useState(false);

  const [Params, setParams] = useState<any>({
    btnAddShow: true,
    expand: false,
    hideFilter: true,
    doclists: [],
    DOCTYPE: [],
    DOCCODE: [],
    isLoading: false,
    objectreference: '',
    isVisibleTask: false,
    random: 0,
    objectname: '',
    previewImage: '',
    previewVisibleDOC: false,
    numPages: null,
    pageNumber: 1,
    scale: 1,
    previewTitle: '',
    isPDF: false,
    showAddDocument: false,
    doccode: '',
    doctype: '',
    loadingUpload: false,
    enableUpload: false,
    ok: true,
  });
  const [ParamsObj, setParamsObj] = useState<any>({
    goodtype: false,
    docid: '',
    doclabel: '',
    isVisibleEvent: false,
    isdocid: 0,
    objectid: objectid,
    tpid: tpid,
    objecttype: objecttype,
    isVisibleTask: true,
    taskid: 0,
    funcode: '',
    titleModal: '',
    objectname: '',
    tasklabel: '',
    objectreference: '',
    object: '',
  });
  const ShowModalExecuteTask = (
    taskid: any,
    funcode: any,
    tasklabel: any,
    object: any,
    objectid: any,
    objectreference: any,
    objectname: any
  ) => {
    setParamsObj({
      taskid: taskid,
      funcode: funcode,
      titleModal: tasklabel,
      object: object,
      docid: objectid,
      objectreference: objectreference,
      objectname: objectname,
      random: _.random(10000000),
    });
    showExecuteTask(true);
  };
  const showExecuteTask = (isVisibleTask: any) => {
    if (isVisibleTask === true) {
      return (
        <EXECUTETask
          handlerModalExecuteTask={handlerModalExecuteTask}
          isVisibleTask={isVisibleTask}
          titleModal={ParamsObj.titleModal}
          taskid={ParamsObj.taskid}
          funcode={ParamsObj.funcode}
          random={ParamsObj.random}
          object={ParamsObj.object}
          objectid={ParamsObj.docid}
          objectreference={ParamsObj.objectreference}
          objectname={ParamsObj.objectname}
        />
      );
    }
  };
  const handlerModalExecuteTask = (val: any) => {
    setParams({ isVisibleTask: false, isVisibleEvent: false });
    if (val === 'Refresh') {
      getListDocByObjectID(
        ParamsObj.objectid,
        ParamsObj.objecttype,
        ParamsObj.tpid
      );
    }
  };
  const getListDocByObjectID = (objectid: any, objecttype: any, tpid: any) => {
    setParams({ isLoading: true });
    findDocumentsByAnyRef({
      doccode: '',
      docmodule: objecttype,
      docstatus: '',
      doctype: '',
      objectid: objectid,
      objectreference: '',
      tpid: tpid,
      tpname: '',
      tpreference: '',
      checkcategory: 'DOC',
      applyFilter: true,
      taskid: 0,
    })
      .then((response) => {
        if (response.code !== '200' && response.code !== '204') {
          notification.error({
            message: response.message,
            description: response.message + ' ' + response.description,
            duration: 0,
          });
          setParams({
            isLoading: false,
          });
        } else {
          setParams({
            doclists: response.list,
          });
          setParams({
            isLoading: false,
          });
        }
      })
      .catch((err) => {
        setParams({
          isLoading: false,
        });
      });
  };
  const onChangeDoctype = (param: any) => {
    getParDocumentByType(param);
  };
  const handlePreviewDOC = (fileurl: any) => {
    let ext = fileurl.substring(fileurl.lastIndexOf('.') + 1);

    if (ext === 'pdf') {
      Params.isPDF = true;
    } else {
      Params.isPDF = false;
    }

    Params.previewImage = fileurl;
    Params.previewVisibleDOC = true;
    Params.previewTitle = fileurl.substring(fileurl.lastIndexOf('/') + 1);
  };
  const handleAddDocument = () => {
    setParams({ showAddDocument: true });
  };

  const handleCancelPreviewDOC = () => setParams({ previewVisibleDOC: false });

  const onChangepdfZoom = (value: any) => {
    setParams({ scale: value / 100 });
  };

  const UpdateDocumentPathbyDocID = (record: any, filename: any) => {
    updateDocPathByDocid({
      docid: record.docid,
      docmodule: record.docmodule,
      docpath: UPLOAD_DOC_URL + filename + localStorage.getItem('lancode'),
      objectid: record.objectid,
    })
      .then((response) => {
        if (response.code !== '200') {
          notification.error({
            message: response.message,
            description: response.message + ' ' + response.description,
            duration: 0,
          });
        } else {
          setParams({ doclists: response.list });
          data = response.list;
        }
      })
      .catch((err) => {});
  };
  // const handleCancelAddDocument = () => setParams({ showAddDocument: false });
  const handleUpdateDocStatus = (
    objectid: number,
    objecttype: any,
    docid: any,
    docstatus: any,
    doublecheck: any
  ) => {
    updateDocStatusByDocid({
      doccheckstatus: doublecheck,
      docid: docid,
      docmodule: objecttype,
      docstatus: docstatus,
      docstatuscomment: docstatus,
      docstatusreason: docstatus,
      objectid: objectid,
      checkcategory: 'DOC',
    }).then((response) => {
      if (response.code !== '200') {
        notification.error({
          message: response.message,
          description: response.message + ' ' + response.description,
          duration: 0,
        });
      } else {
        notification.success({
          message: 'good',
          description: response.message + ' ' + response.description,
        });
      }
      refetch();
    });
  };
  // eslint-disable-next-line no-unused-vars
  const openEvents = (
    objectid: number,
    objecttype: any,
    docid: any,
    doclabel: any
  ) => {
    if (docid != null) {
      setParamsObj({
        objectid: objectid,
        objecttype: objecttype,
        docid: docid,
        doclabel: doclabel,
        isVisibleEvent: false,
      });
      showEventList(false);
    }
  };
  const showEventList = (isVisibleEvent: boolean) => {
    if (isVisibleEvent === true) {
      return (
        <POPOverTaskList
          handlerPopOverEventList={handlerPopOverEventList}
          isVisibleEvent={Params.isVisibleEvent}
          taskid={Params.taskid}
          funcode={Params.funcode}
          random={_.random(10000000)}
          object="DOCUMENT"
          objectid={Params.docid}
          objectreference={Params.doclabel}
          objectname={Params.doclabel}
        />
      );
    }
  };

  const handlerPopOverEventList = (
    taskid: any,
    tasklabel: any,
    funcode: any,
    isVisibleEvent: any
  ) => {
    if (taskid != null) {
      setParamsObj({
        isVisibleEvent: false,
        isVisibleTask: true,
        taskid: taskid,
        funcode: funcode,
        titleModal: tasklabel,
      });
      ShowModalExecuteTask(
        taskid,
        funcode,
        tasklabel,
        'DOCUMENT',
        Params.docid,
        Params.doclabel,
        ''
      );
    }
  };

  const handleUpload = (record: any, info: any) => {
    if (info.file.status === 'uploading') {
      setParams({ loadingUpload: true });
      return;
    }

    if (info.file.status === 'done') {
      if (record === 0 && ParamsObj.goodtype) {
        addDocumentAction(
          objectid,
          objecttype,
          Params.doctype,
          Params.doccode,
          info.file.name
        );
        setParams({ showAddDocument: false, loadingUpload: false });
      } else {
        setParams({ loadingUpload: false });
        UpdateDocumentPathbyDocID(record, info.file.name);
      }
    } else {
      setParams({ loadingUpload: false });
    }
  };
  const addDocumentAction = (
    objectid: any,
    objecttype: any,
    doctype: any,
    doccode: any,
    filename: any
  ) => {
    addDocument({
      doccode: doccode,
      docmodule: objecttype,
      docpath: UPLOAD_DOC_URL + filename,
      doctype: doctype,
      objectid: objectid,
      checkcategory: 'DOC',
      tpid: 0,
      tpreference: '',
      tpname: '',
    })
      .then((response) => {
        if (response.code !== '200') {
          notification.error({
            message: response.message,
            description: response.message + ' ' + response.description,
            duration: 0,
          });
        } else {
          setParams({ ok: false, doclists: response.list });
        }
      })
      .catch((err) => {});
  };
  // eslint-disable-next-line no-unused-vars
  const uploadButton = (
    <div>
      {Params.loadingUpload ? <LoadingOutlined /> : <UploadOutlined />}
      &nbsp;Upload it
    </div>
  );
  const [searchParams, setSearchParams] = useState<FindDocumentsByAnyRefParams>(
    {
      doccode: '',
      docmodule: objecttype || '',
      docstatus: '',
      doctype: '',
      objectid: objectid || 0,
      objectreference: '',
      tpid: tpid || 0,
      tpname: '',
      tpreference: '',
      checkcategory: 'DOC',
      applyFilter: true,
      taskid: 0,
    }
  );
  let { data, refetch, isFetching } = useQuery(
    ['findDocumentsByAnyRef', searchParams],
    () =>
      findDocumentsByAnyRef(searchParams).then((res) => {
        Params.ok = true;
        return res.list || [];
      }),
    { enabled: searchs }
    //{ enabled: ((!isNaN(objectid!) && objecttype==="THIRDPARTY")|| (objectid===undefined)) }
  );

  useEffect(() => {
    if (data) {
      form.setFieldsValue({ [fieldName]: data });
    } else {
      form.setFieldsValue({
        [fieldName]: [],
      });
    }
  }, [form, data]);

  const columns = useMemo<DataGridColDef<DocListSearchResponse>[]>(
    () => [
      {
        dataIndex: 'docid',
        width: '100px',
      },
      {
        dataIndex: 'docmodule',
        //filtrable: true,
        filterComponent: (
          <ParListSelect
            parcode="DOCMODULE"
            style={{ width: '150px' }}
            onChange={(e) => {
              onChangeDoctype(e);
            }}
          />
        ),
        width: '100px',
      },
      {
        dataIndex: 'doctypelabel',
        //filtrable: 'doctype',
        filterComponent: (
          <ParListSelect
            parcode="DOCTYPE"
            style={{ width: '150px' }}
            onChange={(e) => {
              onChangeDoctype(e);
            }}
          />
        ),
        width: '100px',
      },
      {
        dataIndex: 'doclabel',
        width: '250px',
        render: (text, record) =>
          record.docpath != null && !onSelect ? (
            <div>
              {record.doclabel}
              <br></br>
              <a
                onClick={(e) => {
                  e.stopPropagation();
                  handlePreviewDOC(record.docpath);
                }}
                style={{ width: '100%' }}
              >
                {record.docpath.substring(record.docpath.lastIndexOf('/') + 1)}
              </a>
            </div>
          ) : (
            record.doclabel
          ),
      },
      {
        dataIndex: 'objectreference',
        width: '100px',
        render: (value, record) => {
          if (onSelect) {
            return (
              <Typography.Link onClick={() => onSelect(record)}>
                {value}
              </Typography.Link>
            );
          } else <Text> {value} </Text>;
        },
      },
      {
        dataIndex: 'tpreference',
        // filtrable:true,
        comcode: 'Document.tpreference',
        width: '100px',
      },
      {
        dataIndex: 'tpname',
        // filtrable:true,
        comcode: 'Document.tpname',
        width: '200px',
      },
      {
        dataIndex: 'requesttypelabel',
        //filtrable:true,
        comcode: 'Document.requesttypelabel',
        width: '280px',
        align: 'left',
      },
      {
        dataIndex: 'docdoublecheck',
        //filtrable:true,
        comcode: 'Document.docdoublecheck',
        width: '80px',
        align: 'right',
        render: (text, record) => (
          <Checkbox checked={record.docdoublecheck}></Checkbox>
        ),
      },
      {
        dataIndex: 'doccheckstatus',
        comcode: 'Document.doccheckstatus',
        width: '80px',
        align: 'center',
        render: (text, record) =>
          (record.doccheckstatus === 'VALID' && <LikeTwoTone />) ||
          (record.doccheckstatus === 'REFUSE' && <DislikeTwoTone />) ||
          (record.doccheckstatus === 'DDCHECK' && <UserSwitchOutlined />),
      },
      {
        dataIndex: 'doccheckusername',
        //filtrable:true,
        comcode: 'Document.doccheckusername',
        width: '150px',
        align: 'center',
      },
      {
        dataIndex: 'docstatuslabel',
        comcode: 'Document.docstatuslabel',
        width: '120px',
        align: 'center',
        fixed: 'right',
        render: (text, record) =>
          record.doccheckstatus === 'VALID' ? (
            <div style={{ color: 'green' }}>{text}</div>
          ) : record.doccheckstatus === 'REFUSE' ? (
            <div style={{ color: 'red' }}>{text}</div>
          ) : (
            <div style={{ color: 'blue' }}>{text}</div>
          ),
      },
      {
        key: 'operation',
        render: (text, record) => (
          <Row>
            <Col>
              {record.docstatus === 'TOCHECK' &&
                record.docdoublecheck === false && (
                  <AntButton
                    comcode="Validate"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleUpdateDocStatus(
                        record.objectid,
                        record.docmodule,
                        record.docid,
                        'VALID',
                        record.docdoublecheck
                      );
                    }}
                    icon={<LikeTwoTone twoToneColor="green" />}
                  />
                )}
            </Col>
            <Col>
              {record.docstatus === 'VALID' && record.docdoublecheck === false && (
                <AntButton
                  comcode="Refuse"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleUpdateDocStatus(
                      record.objectid,
                      record.docmodule,
                      record.docid,
                      'REFUSE',
                      record.docdoublecheck
                    );
                  }}
                  icon={<DislikeTwoTone twoToneColor="red" />}
                />
              )}
            </Col>
            <Col>
              {record.docdoublecheck === true && record.docstatus !== 'TOLOAD' && (
                <TasksListPopover
                  entityId={record.docid}
                  entityName="DOCUMENT"
                  entityReference={'CODE : ' + record?.doccode}
                  title={record?.doclabel + ' - ' + record?.tpname}
                  onClose={refetch}
                >
                  <AntButton size="small" comcode="action" />
                </TasksListPopover>
              )}
            </Col>
            <Col>
              {(record.docstatus === 'TOLOAD' ||
                record.docstatus === 'REFUSE') && (
                <Upload
                  name="avatar"
                  multiple={false}
                  // action={UPLOAD_DOC_URL}
                  onPreview={Params.handlePreviewDOC}
                  customRequest={(data: any) => {
                    UploadDocumentFile(
                      data.file,
                      ParamsObj.objectreference ?? ''
                    );
                  }}
                  beforeUpload={(file) => {
                    if (
                      file.type.substring(0, 5) !== 'image' &&
                      file.type !== 'application/pdf'
                    ) {
                      notification.error({
                        message: `${file.name} is not a image or pdf file`,
                        description: '',
                        duration: 1,
                      });
                      setParamsObj({ goodtype: false });
                      return false;
                    }
                    setParamsObj({ goodtype: true });
                    return true;
                  }}
                  onChange={(e) => {
                    handleUpload(record, e);
                  }}
                >
                  <AntButton comcode="upload" />
                </Upload>
              )}
            </Col>
          </Row>
        ),
        fixed: 'right',
        width: '100px',
        align: 'right',
      },
    ],

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      handlePreviewDOC,
      refetch,
      Params.handlePreviewDOC,
      handleUpdateDocStatus,
      handleUpload,
    ]
  );

  return (
    <DF.Provider pagcode="doclist">
      <Card title={<GetLabel label="assetDocuments" />}>
        <Form form={form}>
          <Form.Item
            noStyle
            shouldUpdate={(prevValue: Values, nextValue: Values) => {
              return !isEqual(prevValue, nextValue);
            }}
          >
            {() => {
              if (
                Params.doclists !== undefined &&
                Params.doclists?.length !== 0 &&
                !Params.ok
              ) {
                data = Params.doclists;
              }
              const isNewItemInTable = objecttype !== undefined;

              return (
                <DataGrid
                  rowKey="docid"
                  dataSource={data}
                  titleComcode="Document"
                  columns={columns}
                  onSearch={(values) => {
                    setSearchParams(values);
                    setsearchs(true);
                  }}
                  initialSearchValues={searchParams}
                  isLoading={isFetching}
                  extraActions={
                    <>
                      <Checkbox
                        defaultChecked
                        name="applyFilter"
                        onChange={(e) => {
                          searchParams.applyFilter = e.target.checked;
                          setsearchs(true);
                          refetch();
                        }}
                      />
                      <GetLabel label="applyFilters" />
                      &nbsp;&nbsp;
                      <AntButton
                        comcode="add"
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={handleAddDocument}
                        disabled={!isNewItemInTable}
                      />
                    </>
                  }
                />
              );
            }}
          </Form.Item>
        </Form>
      </Card>
      <Modal
        visible={Params.previewVisibleDOC}
        title={Params.previewTitle}
        footer={null}
        onCancel={handleCancelPreviewDOC}
        width="700px"
        style={{
          top: 20,
          right: 0,
        }}
      >
        {Params.isPDF && (
          <div>
            <Row>
              <Col>
                <InputNumber
                  min={10}
                  max={200}
                  formatter={(value) => `${value}%`}
                  step={10}
                  defaultValue={100}
                  onChange={onChangepdfZoom}
                />
              </Col>
            </Row>
            <Document
              file={Params.previewImage}
              onLoadSuccess={Params.onDocumentLoadSuccess}
            >
              <Page pageNumber={Params.pageNumber} scale={Params.scale} />
            </Document>
            <p>
              Page {Params.pageNumber} of {Params.numPages}
            </p>
          </div>
        )}

        {!Params.isPDF && (
          <img
            alt="example"
            style={{ width: '100%' }}
            src={Params.previewImage}
          />
        )}
      </Modal>
    </DF.Provider>
  );
};

export default DocListModal;
